import { Maybe } from '@/types/globals';
import { SpecificationEnum } from '@core/procedure-helpers/models/specification.enum';
import { PonticDesignEnum } from '@shared/models/pontic-design.enum';
import type { ImplantsViewDataRxApi } from './implants-view-data';
import { UnitTypes } from './unit-type.enum';

export interface Tooth {
	ToothID: number | null; // follows ADA numbering always. displayed tooth ids differ according to rx settings
	// not nullable on backend.
	UnitTypeID?: Maybe<UnitTypes>;
	// only number + not nullable on backend.
	MaterialID?: Maybe<number | string>;
	ImplantTypeID?: Maybe<number>;
	ImplantsViewData?: Maybe<ImplantsViewDataRxApi>;
	ShadeSystemId?: Maybe<number>;
	ShadeIncisal?: Maybe<string>;
	ShadeBody?: Maybe<string>;
	ShadeGingival?: Maybe<string>;
	PreparationDesignBuccal?: Maybe<string>;
	PreparationDesignBuccalId?: Maybe<string>;
	PreparationDesignLingual?: Maybe<string>;
	PreparationDesignLingualId?: Maybe<string>;
	MarginDesignBuccal?: Maybe<string>;
	MarginDesignBuccalId?: Maybe<string>;
	MarginDesignLingual?: Maybe<string>;
	MarginDesignLingualId?: Maybe<string>;
	StumpfShade?: Maybe<string>;
	Analog?: Maybe<number>;
	CAMarginStyle?: Maybe<string>;
	CAMarginStyleId?: Maybe<string>;
	CAMaterialID?: Maybe<number>;
	AbutmentType?: Maybe<number>;
	AbutmentMarginStyle?: Maybe<string>;
	AbutmentMarginStyleId?: Maybe<string>;
	AbutmentMaterialId?: Maybe<number>;
	// only number + not nullable on backend.
	SpecificationId?: Maybe<number | string>;
	// not nullable on backend.
	PonticDesignID?: Maybe<PonticDesignEnum>;
	// not nullable on backend.
	ImplantBasedRestorationTypeId?: Maybe<number>;

	// //For bridges
	BridgeIndex?: Maybe<number>;
	InternalToothInBridgeTypeID?: Maybe<number>;
	ToothInBridgeTypeID?: Maybe<number>;
	IsValidForSend?: boolean;

	// Custom materials
	CustomLabMaterialId?: Maybe<number>;
	CustomLabMaterialName?: Maybe<string>;
	CustomLabMaterialGroup?: string;
	CustomLabMaterialRevisionId?: Maybe<number>;

	// Custom specifications
	CustomLabSpecificationId?: Maybe<number>;
	CustomLabSpecificationName?: Maybe<string>;
	CustomLabSpecificationRevisionId?: Maybe<number>;
}

/**
 * @deprecated Use getNewTooth to get new instance.
 */
export const newTooth: Tooth = {
	UnitTypeID: null,
	ToothID: null,
	MaterialID: null,
	SpecificationId: SpecificationEnum.None,
	ImplantBasedRestorationTypeId: null,
	PonticDesignID: null,
	ImplantTypeID: null,
	ImplantsViewData: null,
	ShadeSystemId: null,
	ShadeIncisal: null,
	ShadeBody: null,
	ShadeGingival: null,
	PreparationDesignBuccal: null,
	PreparationDesignBuccalId: null,
	PreparationDesignLingual: null,
	PreparationDesignLingualId: null,
	MarginDesignBuccal: null,
	MarginDesignBuccalId: null,
	MarginDesignLingual: null,
	MarginDesignLingualId: null,
	StumpfShade: null,
	Analog: null,
	CAMarginStyle: null,
	CAMarginStyleId: null,
	CAMaterialID: null,
	AbutmentType: null,
	AbutmentMarginStyle: null,
	AbutmentMarginStyleId: null,
	AbutmentMaterialId: null,
	BridgeIndex: null,
	InternalToothInBridgeTypeID: null,
	ToothInBridgeTypeID: null,
	IsValidForSend: false,
	CustomLabMaterialId: null,
	CustomLabMaterialName: null,
	CustomLabMaterialRevisionId: null,
	CustomLabSpecificationId: null,
	CustomLabSpecificationName: null,
	CustomLabSpecificationRevisionId: null
};

export const getNewTooth = (toothValues?: Partial<Tooth>): Tooth => {
	return { ...newTooth, ...toothValues };
};
